module.exports = __webpack_public_path__ + "static/media/FooterAdornment.d4a8db3d.svg";